import { useState, useEffect, useContext } from "react";
import { Typography, toast } from "@stardust-ds/react";
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import RcmpActionFormCollection from "../../molecules/actionFormCollection";
import { fnFormatDateFromUTC } from "../../../utils/date";
import useDataApi from "../../../hooks/useDataApi";
import { fnShowFormDetails, fnUpdateStatusForm, fnDeleteForm } from "../../../services/forms";
import FormContext from "../../../contexts/Form";
import automationContext from "../../../contexts/Automation";
import { useParams } from "react-router-dom";
import { fnDeleteAutomation } from "../../../services/automation";
import RcmpAlertIcon from "../../../assets/icons/AlertIcon";


export default function RcmpTableFormList(props) {
    const { data, fnOpenNewFunctionality, bIsAutomation, bCanChange, fnOnCloseModalList, fnOpenHistoryModal } = props
    const [oDetailsFormRes, fnDetailsFormReq] = useDataApi(fnShowFormDetails)
    const [oUpdateStatusFormRes, fnUpdateStatusFormReq] = useDataApi(fnUpdateStatusForm)
    const [oDeleteFormRes, fnDeleteFormReq] = useDataApi(fnDeleteForm)
    const [oDeleteAutomationRes, fnDeleteAutomationReq] = useDataApi(fnDeleteAutomation)
    const { nBoardId } = useParams()
    const aCollumns = bIsAutomation ? [
        intl.get("modal_form_list.name"),
        intl.get("modal_new_form.block"),
        intl.get("modal_new_automation.activity_automation"),
        intl.get("modal_new_automation.type"),
        intl.get("modal_form_list.status")
    ] : [
        intl.get("modal_form_list.name"),
        intl.get("modal_form_list.criation"),
        intl.get("modal_form_list.access"),
        intl.get("modal_form_list.sents"),
        intl.get("modal_form_list.status")
    ]
    const { fnSetBUpdateFormList } = useContext(FormContext)
    const { fnChangeInactiveAutomationReq, fnListAutomationReq, fnSetBUpdatedAutomationList } = useContext(automationContext)

    const [nShowTollTip, fnSetNShowTollTip] = useState(-1)
    const [nShowTollTipBlock, fnSetNShowTollTipBlock] = useState(-1)

    useEffect(() => {
        if (!oUpdateStatusFormRes.done) return

        // update form list when status has changed
        if (oUpdateStatusFormRes.data?.success && !oUpdateStatusFormRes.error) {
            // trigger to get new list of forms
            fnSetBUpdateFormList(true)
            return
        }

        // show toast if error when change form status
        if (oUpdateStatusFormRes.error) {
            toast({
                type: "error",
                title: intl.get("modal_form_list.info_inactive_form_error")
            })
        }
    }, [oUpdateStatusFormRes])
    useEffect(() => {
        if (oDeleteFormRes.loading || !oDeleteFormRes.done) return

        // remove deleted form from list
        if (oDeleteFormRes.data?.success && !oDeleteFormRes.error) {
            // trigger to get new list of forms
            fnSetBUpdateFormList(true)
            return
        }

        // show toast if error when change delete form
        if (oDeleteFormRes.error) {
            const cErrorMessage = oDeleteFormRes.error?.response?.data?.message || ""

            toast({
                type: "error",
                title: intl.get("modal_form_list.delete_form_error"),
                description: cErrorMessage
            })
        }
    }, [oDeleteFormRes])
    useEffect(() => {
        if (oDeleteAutomationRes.loading || !oDeleteAutomationRes.done) return

        if (oDeleteAutomationRes.data?.success && !oDeleteAutomationRes.error) {
            // trigger to get new list of forms
            fnSetBUpdatedAutomationList(e => !e)
            return
        }

        // show toast if error when change delete automation
        if (oDeleteAutomationRes.error) {
            const cErrorMessage = oDeleteAutomationRes.error?.response?.data?.message || ""

            toast({
                type: "error",
                title: intl.get("modal_automation_list.delete_automation_error"),
                description: cErrorMessage
            })
        }
    }, [oDeleteAutomationRes])

    async function fnGetDetails(id) {
        const response = await fnDetailsFormReq(id)
    }

    function fnShowToollTip(event, id) {
        const tdElement = event.currentTarget
        const firstChild = tdElement.firstElementChild

        if (firstChild.scrollWidth > firstChild.clientWidth) {
            fnSetNShowTollTip(id)
        }
    }
    function fnShowToollTipBlock(event, id) {
        const tdElement = event.currentTarget
        const firstChild = tdElement.firstElementChild

        if (firstChild.scrollWidth > firstChild.clientWidth) {
            fnSetNShowTollTipBlock(id)
        }
    }

    async function fnHandleChangeFormStatus(oForm, bStatus) {
        if (!bIsAutomation) {
            await fnUpdateStatusFormReq(oForm.id, bStatus)
            return
        } else {
            await fnChangeInactiveAutomationReq(oForm.id)
        }
    }

    async function fnHandleDeleteForm(nFormId, cPassword) {
        return await fnDeleteFormReq(nFormId, cPassword)
    }
    async function fnHandleDeleteAutomation(nFormId, cPassword) {
        return await fnDeleteAutomationReq(nFormId, cPassword)
    }

    async function fnHandleOpenUpdateFormModal(oForm) {

        fnOpenNewFunctionality?.(oForm)
    }
    async function fnHandleOpenUpdateAutomationModal(oForm, bIsActive) {
        fnOpenNewFunctionality?.(oForm, bIsActive)
    }
    function fnRenderCount(form) {
        const cAutomationType = ["activity_expires_in", "activity_expires_ago", "activity_creation", "activity_trigger"].includes(form.type) ? "activity_creation" : "notification_trigger"
        if (cAutomationType === "activity_creation") {
            return form.activityCount
        }
        return form.notificationCount
    }
    return (
        <div className={styles.tableContainer}>
            <table>
                <thead>
                    <tr className={bIsAutomation ? styles.rowOfTableAutomation : styles.rowOfTable}>
                        {aCollumns.map((collumn, i) => {
                            return (
                                <th key={i}><Typography type="p3" color="#737D86">{collumn}</Typography></th>
                            )
                        })}
                    </tr>
                </thead>
                {data?.length > 0 &&
                    <tbody>
                        {data.map((form, i) => {
                            const cAutomationType = ["activity_expires_in", "activity_expires_ago", "activity_creation", "activity_trigger"].includes(form.type) ? intl.get("modal_new_automation.activity_creation") : intl.get("modal_new_automation.notification_trigger")
                            const dCreationDate = fnFormatDateFromUTC(form.createdAt)
                            const creationDtateWithoutTime = dCreationDate.replace(/(\d{2}\/\d{2}\/\d{4}) - \d{2}:\d{2}.*/, "$1")
                            return (
                                !bIsAutomation ? (
                                    <tr className={styles.rowOfTable} key={form.id}>
                                        <td
                                            className={styles.formNameArea}
                                            onClick={() => fnGetDetails(form.id)}
                                            onMouseEnter={(e) => fnShowToollTip(e, form.id)}
                                            onMouseLeave={() => fnSetNShowTollTip(-1)}
                                        >
                                            <p className={styles.formName} >
                                                {form.formName}
                                            </p>
                                            {nShowTollTip === form?.id && <p className={styles.toolltip}>{form.formName}</p>}
                                        </td>
                                        <td>{creationDtateWithoutTime}</td>
                                        <td>{form?.isPublic ? intl.get("modal_form_list.form_is_public") : intl.get("modal_form_list.form_is_no_public")}</td>
                                        <td><p className={styles.activityCount}>{form?.activityCount || 0}</p></td>
                                        <td>
                                            <div className={styles.collectionFormOptions}>
                                                <RcmpActionFormCollection
                                                    form={form}
                                                    fnChangeStatus={fnHandleChangeFormStatus}
                                                    fnDelete={fnHandleDeleteForm}
                                                    fnUpdate={fnHandleOpenUpdateFormModal}
                                                    fnOpenHistoryModal={fnOpenHistoryModal}
                                                    bIsAutomation={false}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    <tr className={styles.rowOfTable} key={form.id}>
                                        <td
                                            className={styles.formNameArea}
                                            onClick={() => fnGetDetails(form.id)}
                                            onMouseEnter={(e) => fnShowToollTip(e, form.id)}
                                            onMouseLeave={() => fnSetNShowTollTip(-1)}
                                        >
                                            <p className={styles.formName} >
                                                {form.title}
                                            </p>
                                            {nShowTollTip === form.id && <p className={styles.toolltip}>{form.title}</p>}
                                        </td>
                                        {/* <td>{form.block.name}</td> */}
                                        <td
                                            className={styles.formNameArea}
                                            onClick={() => fnGetDetails(form.id)}
                                            onMouseEnter={(e) => fnShowToollTipBlock(e, form.id)}
                                            onMouseLeave={() => fnSetNShowTollTipBlock(-1)}
                                        >
                                            <p className={styles.formName} >
                                                {form.block.name}
                                            </p>
                                            {nShowTollTipBlock === form.id && <p className={styles.toolltip}>{form.block.name}</p>}
                                        </td>
                                        <td>
                                            <div className={styles.automationCount}>
                                                <p className={styles.activityCount}>{fnRenderCount(form)}</p>
                                                {/* <RcmpAlertIcon fill={"#FFAE00"} width={"20"} height={"20"} /> */}
                                            </div>
                                        </td>
                                        <td><p style={{ width: "max-content" }}>{cAutomationType}</p></td>
                                        <td>
                                            <div className={styles.collectionFormOptions}>
                                                <RcmpActionFormCollection
                                                    form={form}
                                                    fnChangeStatus={fnHandleChangeFormStatus}
                                                    fnDelete={fnHandleDeleteAutomation}
                                                    fnUpdate={fnHandleOpenUpdateAutomationModal}
                                                    bIsAutomation={bIsAutomation}
                                                    fnOnCloseModalList={fnOnCloseModalList}
                                                    fnOpenHistoryModal={fnOpenHistoryModal}
                                                    type={form.type}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            )
                        })}

                    </tbody>}
            </table>
            {!data?.length &&
                <div className={styles.notForms}>
                    {bIsAutomation ?
                        <>
                            <Typography type="p2" color="#3B454F">{intl.get("modal_automation_list.not_automation_message")}</Typography>
                            {bCanChange && <Typography onClick={fnOpenNewFunctionality} type="l3" color="#6CB6E3">{intl.get("modal_automation_list.create_automation")}</Typography>}
                        </>
                        :
                        <>
                            <Typography type="p2" color="#3B454F">{intl.get("modal_form_list.not_form_message")}</Typography>
                            {bCanChange && <Typography onClick={fnOpenNewFunctionality} type="l3" color="#6CB6E3">{intl.get("modal_form_list.create_form_text")}</Typography>}
                        </>
                    }
                </div>
            }
        </div>
    )
}
